import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (params) {
  return {
    controlType: params.controlType,
    batchExecuteTime1: params.batchExecuteTime1,
    batchExecuteTime2: params.batchExecuteTime2,
    batchExecuteTime3: params.batchExecuteTime3
  }
}
export default { request }
